import { useQuery } from "@tanstack/react-query";
import type { CrmCatalogPreview } from "@ai-crm/shared";
import { Button } from "./ui/button";
import { Switch } from "./ui/switch";
export function CrmUpdateSettings({
  allowLeadUpdates,
  allowContactUpdates,
  onLead,
  onContact,
  loadCatalog,
  queryKey,
  disabled = false,
}: {
  allowLeadUpdates: boolean;
  allowContactUpdates: boolean;
  onLead: (value: boolean) => void;
  onContact: (value: boolean) => void;
  loadCatalog: (entity: "lead" | "contact") => Promise<CrmCatalogPreview>;
  queryKey: string;
  disabled?: boolean;
}) {
  const lead = useQuery({
    queryKey: ["crm-fields", queryKey, "lead"],
    queryFn: () => loadCatalog("lead"),
    enabled: allowLeadUpdates,
    retry: false,
  });
  const contact = useQuery({
    queryKey: ["crm-fields", queryKey, "contact"],
    queryFn: () => loadCatalog("contact"),
    enabled: allowContactUpdates,
    retry: false,
  });
  return (
    <fieldset disabled={disabled} className="space-y-4 rounded-lg border bg-card p-4">
      <legend className="px-1 text-sm font-semibold">Данные CRM</legend>
      <p className="text-sm text-muted-foreground">
        Только существующие информационные поля по данным переписки. Заполненные
        поля могут обновляться.
      </p>
      <label className="flex items-center justify-between gap-4 rounded-md border p-3 text-sm font-medium">
        <span>Заполнять данные сделки</span>
        <Switch
          aria-label="Заполнять данные сделки"
          checked={allowLeadUpdates}
          onCheckedChange={onLead}
        />
      </label>
      <label className="flex items-center justify-between gap-4 rounded-md border p-3 text-sm font-medium">
        <span>Заполнять данные контакта</span>
        <Switch
          aria-label="Заполнять данные контакта"
          checked={allowContactUpdates}
          onCheckedChange={onContact}
        />
      </label>
      {[
        { query: lead, enabled: allowLeadUpdates, label: "Сделка" },
        { query: contact, enabled: allowContactUpdates, label: "Контакт" },
      ]
        .filter((v) => v.enabled)
        .map(({ query, label }) => (
          <div key={label}>
            {query.isPending ? (
              <p role="status">{label}: загрузка полей…</p>
            ) : query.isError ? (
              <p role="alert">
                {label}:{" "}
                {typeof query.error === "object" &&
                query.error &&
                "status" in query.error &&
                query.error.status === 403
                  ? "Недостаточно прав доступа amoCRM."
                  : "Не удалось загрузить каталог полей."}{" "}
                <Button variant="outline" size="sm" type="button" onClick={() => void query.refetch()}>
                  Повторить чтение
                </Button>
              </p>
            ) : (
              <p>
                {label}: найдено полей — {query.data?.fields.length ?? 0}.
              </p>
            )}
          </div>
        ))}
    </fieldset>
  );
}
